import React from 'react';
/**
 * Get country name from country code
 * @param countryCode - ISO 3166-1 alpha-2 country code
 * @returns Country name
 */
export const getCountryName = (countryCode: string): string => {
  const countryMap = {
    US: 'United States',
    GB: 'United Kingdom',
    CA: 'Canada',
    AU: 'Australia',
    DE: 'Germany',
    FR: 'France',
    JP: 'Japan',
    CN: 'China',
    IN: 'India',
    BR: 'Brazil',
    RU: 'Russia',
    ZA: 'South Africa',
    MX: 'Mexico',
    ES: 'Spain',
    IT: 'Italy',
    NL: 'Netherlands',
    SE: 'Sweden',
    SG: 'Singapore',
    AE: 'United Arab Emirates'
    // Add more countries as needed
  };
  return countryMap[countryCode] || countryCode;
};
/**
 * Get default currency for a country
 * @param countryCode - ISO 3166-1 alpha-2 country code
 * @returns Default ISO 4217 currency code for the country
 */
export const getDefaultCurrencyForCountry = (countryCode: string): string => {
  const currencyMap = {
    US: 'USD',
    GB: 'GBP',
    CA: 'CAD',
    AU: 'AUD',
    DE: 'EUR',
    FR: 'EUR',
    JP: 'JPY',
    CN: 'CNY',
    IN: 'INR',
    BR: 'BRL',
    RU: 'RUB',
    ZA: 'ZAR',
    MX: 'MXN',
    ES: 'EUR',
    IT: 'EUR',
    NL: 'EUR',
    SE: 'SEK',
    SG: 'SGD',
    AE: 'AED'
    // Add more countries as needed
  };
  return currencyMap[countryCode] || 'USD';
};
/**
 * Get list of countries
 * @returns Array of country objects with code and name
 */
export const getCountries = (): {
  code: string;
  name: string;
}[] => {
  return [{
    code: 'US',
    name: 'United States'
  }, {
    code: 'GB',
    name: 'United Kingdom'
  }, {
    code: 'CA',
    name: 'Canada'
  }, {
    code: 'AU',
    name: 'Australia'
  }, {
    code: 'DE',
    name: 'Germany'
  }, {
    code: 'FR',
    name: 'France'
  }, {
    code: 'JP',
    name: 'Japan'
  }, {
    code: 'CN',
    name: 'China'
  }, {
    code: 'IN',
    name: 'India'
  }, {
    code: 'BR',
    name: 'Brazil'
  }, {
    code: 'RU',
    name: 'Russia'
  }, {
    code: 'ZA',
    name: 'South Africa'
  }, {
    code: 'MX',
    name: 'Mexico'
  }, {
    code: 'ES',
    name: 'Spain'
  }, {
    code: 'IT',
    name: 'Italy'
  }, {
    code: 'NL',
    name: 'Netherlands'
  }, {
    code: 'SE',
    name: 'Sweden'
  }, {
    code: 'SG',
    name: 'Singapore'
  }, {
    code: 'AE',
    name: 'United Arab Emirates'
  }
  // Add more countries as needed
  ];
};